import { initSlider } from '../../component-library/slider/slider-script';

const initMediaSlider = (sliderEl) => {
	return initSlider(sliderEl, {
		perPage: 4,
		focus: 'center',
		type: 'loop',
		drag: true,
		autoPlay: true,
		breakpoints: {
			1920: {
				perPage: 2,
			},
			1024: {
				perPage: 1.5,
			},
			767: {
				perPage: 1.25,
			},
		},
	});
};

document.querySelectorAll('.media-slider__slider').forEach((sliderEl) => {
	initMediaSlider(sliderEl);
});
